import ReactDOM from 'react-dom'

import { compose, lifecycle, withHandlers } from 'recompose'

type InnerTop = {
  handleEscKeyPress: (event: KeyboardEvent) => void
}

type InnerBottom = {
  toggleListeners: (on: boolean, element: HTMLElement) => void
}

export default <T = {}>(
  onEscKeyPress: (props: T) => void,
  eventName = 'keydown',
) =>
  compose(
    withHandlers<T, InnerTop>({
      handleEscKeyPress: (props: T) => (event) => {
        const key = event.key || event.keyCode
        if (key === 'Escape' || key === 'Esc' || key === 27) {
          onEscKeyPress(props)
        }
      },
    }),
    withHandlers<InnerTop, InnerBottom>({
      toggleListeners:
        ({ handleEscKeyPress }) =>
        (on: boolean, element: HTMLElement) => {
          if (element) {
            const method: 'addEventListener' | 'removeEventListener' = on
              ? 'addEventListener'
              : 'removeEventListener'
            element[method](eventName, handleEscKeyPress as any, true)
          }
        },
    }),
    lifecycle<InnerBottom, {}, any>({
      componentDidMount() {
        const element = ReactDOM.findDOMNode(this) as HTMLElement
        element.tabIndex = 0
        this.props.toggleListeners(true, element)
      },
      componentWillUnmount() {
        const element = ReactDOM.findDOMNode(this) as HTMLElement
        element.tabIndex = 0
        this.props.toggleListeners(false, element)
      },
    }),
  )
